import { ImageIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { Plugin } from "types";
import { elrondUri } from "../../api/elrondApi";

interface PluginImageProps {
    plugin: Plugin;
    className?: string;
}

export const PluginImage = ({ plugin, className }: PluginImageProps) => {
    const pluginLogoUrl = plugin.logo && `${elrondUri}${plugin.logo.url}`;

    if (pluginLogoUrl) {
        return <img src={pluginLogoUrl} className={clsx("rounded object-cover", className)} alt={plugin.name} />;
    }

    return (
        <div className={clsx("flex items-center justify-center rounded bg-gray-lighter", className)}>
            <ImageIcon size="large" className="text-gray" />
        </div>
    );
};
